import { connect } from 'react-redux';

import { FatPanel, IFatPanelProps } from '../../components/FatPanel';
import { IState } from '../../store';

export type TStoreProps = Pick<IFatPanelProps, 'isHidden'>;

export function mapStateToProps(state: IState): TStoreProps {
  return {
    isHidden: !state.isFatCard,
  };
}

export const FatPanelContainer = connect<TStoreProps>(mapStateToProps)(FatPanel);
